module.exports = __webpack_public_path__ + "img/help-ct3.c0970f70.png";